module.exports = __webpack_public_path__ + "img/discod.c8ec25a.png";